.drawer {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 5.5rem;
}

.selectContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}

.select {
  width: 100%;
}

.assignButton {
  margin-top: 12px;
  height: 50px;
}

.doneButton {
  width: 100%;
}

.drawerFooter {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  column-gap: 0.5rem;
  border-top: 1px solid var(--color-neutral-200);
  background-color: #fff;
  padding: 1rem 1.5rem;
}
